import { useEffect } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { gql, useQuery } from "@apollo/client";

import AlbumReviewGrid from "@/components/common/AlbumReviewGrid";
import AlbumReviewThumbnail from "@/components/reviews/AlbumReviewThumbnail";
import Pagination from "@/components/Pagination";
import PageHeader from "@/components/PageHeader";
import handleStaticProps from "src/lib/handle-static-props";
import Seo from "@/components/seo";
import Loader from "@/components/common/Loader/Loader";

export async function getStaticProps() {
  const { result } = await handleStaticProps({
    pageQuery,
    variables: { page: 1 },
  });

  return result;
}

function AlbumReviewsPage() {
  const router = useRouter();
  const page = parseInt(router.query.page) || 1;
  const { data, refetch } = useQuery(pageQuery, { variables: { page } });

  useEffect(() => {
    refetch({
      variables: { page },
    });
  }, [page, refetch]);

  return (
    <div className="container">
      <Seo title="Album Reviews" />
      <PageHeader>
        <Link href="/blog/" style={{ fontSize: 12 }}>
          &#60;&#60; TO THE BLOG <br />
        </Link>
        Album Reviews
      </PageHeader>
      {data ? (
        <>
          <AlbumReviewGrid
            reviews={data.allReviews.edges}
            contentComponent={AlbumReviewThumbnail}
          />
          <Pagination
            activePage={data.allReviews.page}
            maxPages={data.allReviews.pages}
            pageRangeDisplayed={3}
          />
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
}

export default AlbumReviewsPage;

const pageQuery = gql`
  query AlbumReviewsPage($page: Int) {
    allReviews(page: $page) {
      page
      pages
      hasNext
      hasPrev
      edges: objects {
        __typename
        id
        artist
        cover
        genre
        newbin
        slug
        title
        url
      }
    }
  }
`;
